import '../modules/slider-mobile-swipe';
import '../modules/tabs';
import '../modules/counter';

$('.js-scroll-to').on('click', function () {
  $('.page-item-complect__tabs').find('.tabs__btn').trigger('click');
});